export const MANAGER = 'manager';
export const SELF = 'self';
export const ADMIN = 'admin';
export const B2B = 'review_each_other';
export const PEER = 'peer';
